import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';
import {
  MTAssumptionsSection,
  MTCalc,
  MTCTAv2,
  MTDivider,
  MTHeader,
  MTLearnMore,
  MTLearnMoreItem,
  MTScorePanel,
  MTSkinny,
  MTSubcontent,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentHR,
  MTSubcontentLabel,
  MTSubcontentP,
  MTSubheading,
  MTWide,
} from '../Microtools/layout';
import { CustomCTA } from '../Onboarding/PlanIntro';

import { runFullSimulation } from '../../actions/simulationActions';
import { trackEvent } from '../../actions/trackEventActions';
import { updateFrame } from '../../actions/uiActions';
import { wlPath, wlVar } from '../../helpers/whitelabel';

// for some reason Chrome on Windows needs a bit of extra height (hence +15px)
const IFrameContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: ${props => (props.height ? `${props.height + 15}px` : '100%')};
`;

const StyledIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => `${props.height}px` || '100%'};
  border: 0;
`;

export class MarketVolatility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iFrameHeight: undefined,
    };
  }

  componentDidMount() {
    this.props.updateFrame('How could a Financial Crash affect you?', 'bloombergscreen.jpeg');
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }

    // wait for iFrame to load
    this.checkIfIFrameLoaded();
    //window.addEventListener('resize', this.updateIFrameHeight);
  }

  checkIfIFrameLoaded = () => {
    const iFrame = document.getElementById('calc-iframe');
    const iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    if (iFrameDoc.readyState === 'complete' && iFrameDoc.getElementsByTagName('body').length) {
      // add a listener that will update the height if it's changed
      this.onElementHeightChange(iFrame, this.updateIFrameHeight);
      this.updateIFrameHeight();
      return;
    }
    window.setTimeout(this.checkIfIFrameLoaded, 100);
  };

  onElementHeightChange = (el, callback) => {
    let lastHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    let newHeight;
    (function run() {
      if (el.contentWindow.document.getElementsByTagName('body').length) {
        newHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
        if (lastHeight != newHeight) {
          callback();
        }
      }

      lastHeight = newHeight;

      if (el.onElementHeightChangeTimer) {
        clearTimeout(el.onElementHeightChangeTimer);
      }

      el.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  };

  updateIFrameHeight = () => {
    this.setState({
      iFrameHeight: this.getIFrameHeight(),
    });
  };

  getIFrameHeight = () => {
    const newiFrameHeight = document
      .getElementById('calc-iframe')
      .contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    return newiFrameHeight;
  };

  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateIFrameHeight);
  }

  render() {
    const { results } = this.props;

    if (!results) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="" />
        <MTSkinny>
          <MTSubcontent noCard>
            <MTSubcontentP>
              Nobody can predict when a crash will happen, but it’s a good idea to look ahead, and understand the
              potential impact on your finances, and what you can do to mitigate it.
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubheading title="See what’s at stake." />
          <MTSubcontent noCard>
            <MTSubcontentP>
              This interactive tool helps you visualize how your savings would be affected during a major crash, and in
              the years that follow. It will also explain the main decisions you can make now that will decide how
              “painful” the crash ends up being, if or when it ever happens.
            </MTSubcontentP>
          </MTSubcontent>

          {/* placeholder for iframe */}
          <IFrameContainer height={this.state.iFrameHeight}>
            <StyledIFrame id="calc-iframe" src="/calculators/market_volatility" height={this.state.iFrameHeight} />
          </IFrameContainer>
        </MTSkinny>
        <CustomCTA heading="Find out how to protect your investments." trackEvent={this.props.trackEvent}>
          <Typography
            tag="div"
            use="body1"
            className="pt-2"
            theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
          >
            The key to surviving (and thriving) in a difficult market is preparation: understand what’s at stake, and
            what you can do to influence the outcome. If you’re ready to take a deeper look at how you can better
            protect yourself from market volatility, schedule a free intro!
          </Typography>
        </CustomCTA>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    results: state.simulations.results,
  };
}

export default connect(mapStateToProps, { runFullSimulation, trackEvent, updateFrame })(MarketVolatility);
